var go = require('gojs');
var diagramConfiguration = require('../../diagramConfiguration');

const $ = go.GraphObject.make;

function normalizeSide(side) {
  const normalized = String(side || '').toLowerCase();
  return ['left', 'right', 'top', 'bottom'].includes(normalized) ? normalized : 'bottom';
}

function sortConnections(a, b) {
  const slotComparison = (Number(a && a.portSlot) || 0) - (Number(b && b.portSlot) || 0);
  if (slotComparison !== 0) return slotComparison;
  return String((a && a.label) || '').localeCompare(String((b && b.label) || ''));
}

function connectionsForSide(connections, side) {
  if (!Array.isArray(connections)) return [];
  return connections
    .filter(connection => normalizeSide(connection && connection.side) === side)
    .sort(sortConnections);
}

function createAnnotationToolTip() {
  return $('ToolTip',
    $(go.TextBlock,
      {
        margin: 4,
        stroke: '#1f2933',
        font: `500 ${Math.max(diagramConfiguration.fontSize - 4, 7)}pt 'Roboto Flex', monospace`
      },
      new go.Binding('text', 'label')
    )
  );
}

function createAnnotationItemTemplate() {
  const cellWidth = diagramConfiguration.calculateCellWidth();
  const cellHeight = diagramConfiguration.calculateCellHeight();
  const markerSize = Math.max(5, Math.min(cellWidth, cellHeight) * 0.58);

  return $(go.Panel, 'Spot',
    {
      desiredSize: new go.Size(cellWidth, cellHeight),
      opacity: 0.82,
      isActionable: false,
      toolTip: createAnnotationToolTip()
    },
    $(go.Shape, 'Circle',
      {
        desiredSize: new go.Size(markerSize, markerSize),
        stroke: '#17202a',
        strokeWidth: 1
      },
      new go.Binding('fill', 'linkColor')
    )
  );
}

function createSidePanel(side, orientation, alignment, alignmentFocus, margin) {
  return $(go.Panel, orientation,
    {
      alignment: alignment,
      alignmentFocus: alignmentFocus,
      margin: margin,
      isActionable: false,
      itemTemplate: createAnnotationItemTemplate()
    },
    new go.Binding('visible', 'externalConnections', function(connections) {
      return connectionsForSide(connections, side).length > 0;
    }),
    new go.Binding('itemArray', 'externalConnections', function(connections) {
      return connectionsForSide(connections, side);
    })
  );
}

function createExternalConnectionAnnotations() {
  return $(go.Panel, 'Spot',
    {
      row: 1,
      column: 1,
      stretch: go.GraphObject.Fill,
      isActionable: false
    },
    new go.Binding('visible', 'externalConnections', function(connections) {
      return Array.isArray(connections) && connections.length > 0;
    }),
    createSidePanel('left', 'Vertical', go.Spot.Left, go.Spot.Left, new go.Margin(0, 0, 0, 2)),
    createSidePanel('right', 'Vertical', go.Spot.Right, go.Spot.Right, new go.Margin(0, 2, 0, 0)),
    createSidePanel('top', 'Horizontal', go.Spot.Top, go.Spot.Top, new go.Margin(2, 0, 0, 0)),
    createSidePanel('bottom', 'Horizontal', go.Spot.Bottom, go.Spot.Bottom, new go.Margin(0, 0, 2, 0))
  );
}

module.exports = createExternalConnectionAnnotations;
